import { ContactInfoMode } from '../utils/contact-info.validator';

/**
 * Mirrors the backend `AllowedContactMethods` enum (CPO-4261).
 * Intentionally local — not exported from this package.
 */
export const enum AllowedContactMethods {
    Email = 1,
    Phone = 2,
    Both = 3,
}

/**
 * Maps a backend AllowedContactMethods value to the ContactInfoMode string
 * expected by validateContactInfo.
 *
 * Out-of-range values are handled by the caller (fail-closed to email-only).
 */
export const contactMethodToMode: Record<AllowedContactMethods, ContactInfoMode> = {
    [AllowedContactMethods.Email]: 'email-only',
    [AllowedContactMethods.Phone]: 'phone-only',
    [AllowedContactMethods.Both]: 'either',
};
